// import 'react-toastify/dist/ReactToastify.css';

import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Link, Redirect, Route, Switch } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBars,
    faDownload,
    faFileDownload,
    faFileImport,
    faFileInvoiceDollar,
    faFilter,
    faHome,
    faPaperPlane,
    faStroopwafel,
    faSyncAlt,
} from '@fortawesome/free-solid-svg-icons';
import { UnsuporterPage } from 'zina-dogi-react';

import Landing from '../apps';
import logo from '../assets/imgs/nokia-logo-white.svg';
import { BigLoading, ExtraMenu, NotificationMenuItem } from '../components';
import { PrivateRoute } from '../components/private_route/private_route';
import { auth, notificationsActions, projectListActions, siteActions } from '../shared';
import { authSelectors } from '../shared/redux/auth/selectors';
import { subprojectSelectors } from '../shared/redux/dashboard/selectors';
import { notificationsSelectors } from '../shared/redux/notifications/selectors';
import {
    ActivityReport,
    ApprovalUserMail,
    ApprovalUserProjectUser,
    AssignTeamLeader,
    ClientError,
    ClientMaintenance,
    ConfigurationRules,
    CustomReport,
    Dashboard,
    DashboardDetails,
    Dataset,
    DispatchLogs,
    EditRole,
    EditSite,
    EditUserManagement,
    Exporter,
    GapAnalysis,
    GapAnalysisDetails,
    GroupsColorSetting,
    Importer,
    ImporterConfiguration,
    ImporterCriteriaGroup,
    ImporterIntegration,
    ImporterRole,
    ImporterRules,
    ImporterTemplateSyncSMR,
    ImportGroupEmails,
    ImportPeriod,
    ImportShortcutKeys,
    ImportUsers,
    KpiConfiguration,
    kpisInformation,
    ListProject,
    ListReport,
    LogicalFilterConfig,
    LogsReportContainer,
    NewSite,
    Notification,
    NotificationAlert,
    Profile,
    projectConfiguration,
    ProjectList,
    ResetPassword,
    Role,
    SSOLogin,
    SyncWebClaro,
    SyncZina,
    TmoSiteBased,
    UserActivityResponsible,
    UserManagement,
    UserReport,
    Validate,
    WebtoolSynch,
} from './';

library.add(
    faStroopwafel,
    faFilter,
    faSyncAlt,
    faPaperPlane,
    faHome,
    faDownload,
    faBars,
    faFileInvoiceDollar,
    faFileImport,
    faFileDownload
);

const minBrowserVersions = {
    chrome: '65',
    firefox: '60',
    edge: '15',
    'edge-chromium': '85',
};

const { detect } = require('detect-browser');
const cmp = require('semver-compare');

class Root extends Component {
    constructor(props) {
        super(props);
        this.state = {
            browser: null,
            supported: false,
        };
    }

    componentDidMount() {
        this.onCheck(detect());
    }

    componentDidUpdate(prevProps) {
        // Update the bell icon badge when the notification count changes OR when the header
        // appears in the DOM for the first time (lazy-loaded route chunks finish loading).
        // Without the isNewlyMounted check, the badge would never be set on page reload because
        // the API response arrives while Suspense is still showing the BigLoading fallback,
        // and by the time the header renders the count no longer changes.
        const count = this.props.notifications?.count || 0;
        const prevCount = prevProps.notifications?.count || 0;
        const bellIcon = document.querySelector('.header .controls .fa-bell');
        const bellToggle = bellIcon?.parentElement;

        if (!bellToggle) {
            return;
        }

        const isNewlyMounted = !bellToggle.classList.contains('bell-toggle');
        const countChanged = prevCount !== count;

        if (isNewlyMounted || countChanged) {
            bellToggle.classList.add('bell-toggle');

            if (count > 0) {
                bellToggle.setAttribute('data-badge', count > 99 ? '99+' : String(count));
            } else {
                bellToggle.removeAttribute('data-badge');
            }
        }

        // Trigger ring + badge-pop animation when new notifications arrive
        if (count > prevCount) {
            bellToggle.classList.add('bell-toggle--pulse');
            setTimeout(() => bellToggle.classList.remove('bell-toggle--pulse'), 900);
        }
    }

    cleanConfigurationAdvancedSearch(prevProps) {
        const {
            subprojectId,
            FilterValueProjectList,
            FilterLogicSearchValueProjectList,
            setAdvanceFilter,
            setGrouperSelected,
            fetchNotificationsUnread,
        } = this.props;

        if (subprojectId !== prevProps.subprojectId) {
            FilterValueProjectList({
                filter: [],
                isFilter: false,
                columns: [{ label: 'Item' }],
                columnsHeader: ['Item'],
                dataGrid: [[{ value: '' }]],
            });
            FilterLogicSearchValueProjectList({
                isFilter: false,
                filter: null,
                dataFilterValue: null,
            });
            setAdvanceFilter({ data: [], selected: '' });
            setGrouperSelected(null);
            fetchNotificationsUnread(subprojectId);
        }
    }

    render() {
        const { browser, supported } = this.state;
        const year = new Date().getFullYear();
        const { notifications, ...props } = this.props;

        const extraProps = {
            ...props,
            copyright: `© 2018 - ${year} Nokia | Powered by ZINA`,
            extraMenu: <ExtraMenu />,
            notification: {
                page: '/rollout/notifications/',
                size: notifications.count,
                list: notifications.results,
                component: (props) => <NotificationMenuItem {...props} />,
                onClick: () => props.fetchNotificationsUnread(props.subprojectId),
            },
            userMenuItems: (_on_logout) => {
                return (
                    <>
                        <Link
                            to="/rollout/profile/"
                            style={{ color: '#212529', fontWeight: '400' }}
                            className="dropdown-item btn "
                            onClick={() => console.log('profile')}
                        >
                            <i className="fas fa-user" /> Profile
                        </Link>

                        <button className="dropdown-item btn" onClick={() => props.logout()}>
                            <i className="fas fas fa-power-off" /> Logout
                        </button>
                    </>
                );
            },
        };

        return (
            <div className="h-100">
                {!supported && browser && <UnsuporterPage browser={browser} />}
                {supported && (
                    <div>
                        <NotificationAlert />
                        <BrowserRouter>
                            <Suspense fallback={<BigLoading />}>
                                <Switch>
                                    <Route
                                        exact
                                        path="/login/"
                                        render={(props) => <Landing {...props} />}
                                    />
                                    <Route
                                        exact
                                        path="/landing/"
                                        render={(props) => <Landing {...props} />}
                                    />
                                    <Route
                                        exact
                                        path="/approval_user_project_lineManager/:token"
                                        render={(props) => <ApprovalUserMail {...props} />}
                                    />
                                    <Route
                                        key="sso_login"
                                        exact
                                        path="/login-sso/"
                                        component={(props) => <SSOLogin {...props} />}
                                    />
                                    <Route
                                        key="sso_validate"
                                        exact
                                        path="/sso/validate/"
                                        component={(props) => <Validate {...props} />}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/configuration/logical-filter/"
                                        component={LogicalFilterConfig}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/import-emails-by-status/"
                                        component={ImportGroupEmails}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/import-period/"
                                        component={ImportPeriod}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/importer/shortcut/"
                                        component={ImportShortcutKeys}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/import-criteria-group/"
                                        component={ImporterCriteriaGroup}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/import-template-sync-smr/"
                                        component={ImporterTemplateSyncSMR}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/integration/import-email-configurations/"
                                        component={ImporterIntegration}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/integration/sync-dispatch-logs/"
                                        component={DispatchLogs}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/integration/sync-zina/"
                                        component={SyncZina}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/integration/claro-sync/"
                                        component={SyncWebClaro}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/custom-report/"
                                        component={CustomReport}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/logs_general/"
                                        component={LogsReportContainer}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/list_report/"
                                        component={ListReport}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/monitor_webtool_synch/"
                                        component={WebtoolSynch}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/activity/report/"
                                        component={ActivityReport}
                                    />
                                    <Route
                                        path="/profile/reset/password/:uidb64/:token/"
                                        render={(props) => <ResetPassword {...props} />}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/"
                                        component={Dashboard}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/dashboard/"
                                        component={Dashboard}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path={`/dashboard/details/:grouper/:nameActivity`}
                                        component={DashboardDetails}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/dashboard/gap/"
                                        component={GapAnalysis}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/dashboard/gap/:grouper/:title"
                                        component={GapAnalysisDetails}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/kpi/"
                                        component={kpisInformation}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/configuration/kpi-configuration/"
                                        component={KpiConfiguration}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/importer/"
                                        component={Importer}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/export/"
                                        component={Exporter}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/project-list/new-site/"
                                        component={NewSite}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/project-list/edit-site/:siteId"
                                        component={EditSite}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/project-list/"
                                        component={ProjectList}
                                    />
                                    {props?.generalConfiguration?.dashboard_consolidated ? (
                                        <PrivateRoute
                                            extraProps={extraProps}
                                            exact
                                            keyPermissions=""
                                            path="/rollout/tmo/"
                                            component={TmoSiteBased}
                                        />
                                    ) : (
                                        ''
                                    )}
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/notifications/"
                                        component={Notification}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/dataset/"
                                        component={Dataset}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions=""
                                        path="/rollout/profile/"
                                        component={Profile}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/user-management/edit-user/:userId/"
                                        component={EditUserManagement}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/user-management/"
                                        component={UserManagement}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/user-management/imports"
                                        component={ImportUsers}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/user-management/reports"
                                        component={UserReport}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/user-management/responsible"
                                        component={UserActivityResponsible}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/role"
                                        component={Role}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/role/importer"
                                        component={ImporterRole}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/role/edit/:rolId"
                                        component={EditRole}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/profile/user-management/user_project_approval"
                                        component={ApprovalUserProjectUser}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/project/configuration/"
                                        component={projectConfiguration}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/project/color-setting/"
                                        component={GroupsColorSetting}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/importer/backbone/"
                                        component={ImporterConfiguration}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/project/list/"
                                        component={ListProject}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/configuration/rules/"
                                        component={ConfigurationRules}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/configuration/rules_import/"
                                        component={ImporterRules}
                                    />
                                    <PrivateRoute
                                        extraProps={extraProps}
                                        exact
                                        keyPermissions="admin_views"
                                        path="/rollout/assign-team-leader/"
                                        component={AssignTeamLeader}
                                    />
                                    <Route
                                        extraProps={extraProps}
                                        exact
                                        path="/not-found/:typeError/"
                                        render={(props) => <ClientError {...props} />}
                                    />
                                    <Route
                                        extraProps={extraProps}
                                        exact
                                        path="/maintenance/"
                                        render={(props) => <ClientMaintenance {...props} />}
                                    />
                                    <Redirect to="/" />
                                </Switch>
                            </Suspense>
                        </BrowserRouter>
                    </div>
                )}
            </div>
        );
    }

    onCheck = (browser) => {
        let supported = false;

        if (browser) {
            if (minBrowserVersions[browser.name]) {
                const version = minBrowserVersions[browser.name];
                const diff = cmp(browser.version, version);

                if (diff >= 0) {
                    supported = true;
                }
            }
        }

        this.setState({ browser, supported });
    };
}

const mapStateToProps = (store) => {
    return {
        user: authSelectors.getUser(store),
        subprojectId: subprojectSelectors.getSubprojectSelected(store),
        notifications: notificationsSelectors.getNotificationsUnread(store),
        logo,
        generalConfiguration: subprojectSelectors.getGeneralConfiguration(store),
        config: subprojectSelectors.getOptionsMenuAllowed(store),
        userHasProjectAssigned: subprojectSelectors.userHasProjectAssigned(store),
        isRolloutProject: subprojectSelectors.isRolloutProject(store),
        hasPermissionDashboardView: subprojectSelectors.hasPermissionDashboardView(store),
    };
};

const mapDispatchToProps = (dispatch) => ({
    logout: () => {
        dispatch({ type: 'RESET' });
        dispatch(auth.actions.logOut());
    },
    FilterValueProjectList: (filter) => {
        dispatch(projectListActions.dataFilterValueProjectList(filter));
    },
    FilterLogicSearchValueProjectList: (filter) => {
        dispatch(projectListActions.filterByLogicSearch(filter));
    },
    setAdvanceFilter: (advanceFilter) => {
        dispatch(projectListActions.advanceLogicFiltersSearchSSet(advanceFilter));
    },
    setGrouperSelected: (idGrouper) => {
        dispatch(siteActions.gropuerSelected(idGrouper));
    },
    fetchNotificationsUnread: (subprojectId) => {
        dispatch(notificationsActions.fetchNotificationsUnread(subprojectId));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
